import { jsx as _jsx } from "react/jsx-runtime";
import { Stepper } from "@opala-ds/react";
import AddressDataForm from "../Forms/AddressDataForm";
import PersonalDataForm from "../Forms/PersonalDataForm";
import useTechnicalStore from "../../stores/technicalStore";
import { useIsMobile } from "../../hooks/useIsMobile";
import SchoolDataForm from "../Forms/technicalForms/SchoolDataForm";
import ProfessionalDataForm from "../Forms/technicalForms/ProfessionalDataForm";
import TermsAndConditionsTechnicalForm from "../Forms/technicalForms/TermsAndConditionsTechnicalForm";
import { useCreateTechnical } from "../../queries/jepis";
export default function TechnicalStepper() {
    var personalData = useTechnicalStore(function (state) { return state.personalData; });
    var addressData = useTechnicalStore(function (state) { return state.addressData; });
    var professionalData = useTechnicalStore(function (state) { return state.professionalData; });
    var schoolData = useTechnicalStore(function (state) { return state.schoolData; });
    var setPersonalData = useTechnicalStore(function (state) { return state.setPersonalData; });
    var setAddressData = useTechnicalStore(function (state) { return state.setAddressData; });
    var setSchoolData = useTechnicalStore(function (state) { return state.setSchoolData; });
    var setTermsAndConditionsData = useTechnicalStore(function (state) { return state.setTermosAndConditions; });
    var setProfessionalData = useTechnicalStore(function (state) { return state.setProfessionalData; });
    var isMobile = useIsMobile();
    var createTechnical = useCreateTechnical().mutate;
    return (_jsx(Stepper, { showIndicator: !isMobile, initialStep: 0, orientation: "horizontal", steps: [
            {
                content: (_jsx(PersonalDataForm, { defaultValues: personalData, onSubmit: setPersonalData })),
                title: "Dados Pessoais do Técnico",
            },
            {
                content: (_jsx(AddressDataForm, { defaultValues: addressData, onSubmit: setAddressData })),
                title: "Endereço",
            },
            {
                content: (_jsx(SchoolDataForm, { defaultValues: schoolData, onSubmit: setSchoolData })),
                title: "Dados escolares",
            },
            {
                content: (_jsx(ProfessionalDataForm, { defaultValues: professionalData, onSubmit: setProfessionalData })),
                title: "Dados profissionais",
            },
            {
                content: (_jsx(TermsAndConditionsTechnicalForm, { onSubmit: function (data) {
                        setTermsAndConditionsData(data);
                        createTechnical({
                            payload: {
                                addressData: addressData,
                                personalData: personalData,
                                professionalData: professionalData,
                                termsAndConditionsData: data,
                                schoolData: schoolData,
                            },
                        });
                    } })),
                title: "Aceite dos Termos e Condições",
            },
        ], textAlignment: "center" }));
}
